import { Avatar, Stack, Title } from "@mantine/core"
import { primaryColor } from "../../../../constants/theme"

export const NoSearchResults = () => {

    return(
        <Stack justify="center" align="center" h='40vh'>
            <Avatar size={120} radius={120} mx='auto' color={primaryColor} />
            <Title order={3} fw='normal' ta='center'>No results found</Title>
            <Title order={5} fw='normal' ta='center' c='dimmed'>Try adjusting your search to find what you're looking for.</Title>
        </Stack>
    )
}